import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-auto q-pa-md chat-wrapper chat-messages"
}
const _hoisted_2 = { class: "q-pa-md bg-neutral rounded overflow-auto" }
const _hoisted_3 = { class: "full-width q-px-md chat-wrapper chat-input" }

import { computed, ref, watch } from "vue";
import { chatApiStore, chatStore } from "@/hooks";
import {
  IconButton,
  ListItem,
  Typography,
  Icon,
  FlexBox,
  PopupEditInput,
} from "@/components/common";
import { ArtifactChip } from "@/components/artifact";


/**
 * Displays chat messages between a member and SAFA AI.
 */
const __default__ = {
  name: "ProjectChatMessages",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const scrollId = "chat-bottom";

const currentMessage = ref("");
const editing = ref(false);

const messages = computed(() => chatStore.currentMessages);

const formattedMessages = computed(() => chatStore.currentMessagesDisplay);

/**
 * Sends a chat message to the server.
 */
function handleSendMessage() {
  chatApiStore.handleSendChatMessage(
    chatStore.currentChat,
    currentMessage.value
  );

  currentMessage.value = "";
}

/**
 * Emits an event when enter is clicked and sends the message associated with the specific chat.
 * @param e - The keyboard event.
 */
function handleKeydown(e: KeyboardEvent) {
  if (e.key === "Enter") {
    handleSendMessage();
    e.preventDefault(); // To prevent form submission or other default actions
  }
}

/**
 * Saves an edit to the chat title.
 * @param title - The new chat title.
 */
function handleSaveEdit(title: string) {
  chatApiStore.handleEditProjectChat(title);

  editing.value = false;
}

/**
 * Scrolls to the bottom of the chat when a new message is added.
 */
watch(
  () => messages.value,
  () => {
    setTimeout(() => {
      document.getElementById(scrollId)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_page, null, {
        default: _withCtx(() => [
          _createVNode(_unref(PopupEditInput), {
            value: _unref(chatStore).currentChat.title,
            editing: editing.value,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (editing.value = false)),
            onOpen: _cache[1] || (_cache[1] = ($event: any) => (editing.value = true)),
            onSave: handleSaveEdit
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Typography), {
                variant: "subtitle",
                value: _unref(chatStore).currentChat.title,
                el: "h2",
                class: "q-py-sm q-pl-md"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["value", "editing"]),
          (!_unref(chatApiStore).loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formattedMessages.value, (message, idx) => {
                  return (_openBlock(), _createBlock(_unref(ListItem), {
                    id: `message-${idx}`,
                    key: message.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FlexBox), {
                        b: "1",
                        "full-width": ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(message.iconClass)
                          }, [
                            _createVNode(_unref(Icon), {
                              color: message.iconColor,
                              variant: message.iconVariant,
                              size: "md",
                              class: "q-mr-md q-mt-md"
                            }, null, 8, ["color", "variant"])
                          ], 2),
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(Typography), {
                              variant: "subtitle",
                              value: message.userName
                            }, null, 8, ["value"]),
                            _createVNode(_unref(Typography), {
                              variant: "markdown",
                              value: message.message
                            }, null, 8, ["value"]),
                            (message.artifacts.length > 0)
                              ? (_openBlock(), _createBlock(_unref(FlexBox), {
                                  key: 0,
                                  wrap: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.artifacts, (relatedArtifact) => {
                                      return (_openBlock(), _createBlock(_unref(ArtifactChip), {
                                        key: relatedArtifact.id,
                                        artifact: relatedArtifact
                                      }, null, 8, ["artifact"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["id"]))
                }), 128)),
                _createElementVNode("div", { id: scrollId })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_input, {
              modelValue: currentMessage.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentMessage).value = $event)),
              outlined: "",
              loading: _unref(chatApiStore).loading || _unref(chatApiStore).loadingResponse,
              disable: _unref(chatApiStore).loadingResponse,
              placeholder: "Ask a question",
              class: "full-width bg-neutral",
              clearable: "",
              onKeydown: handleKeydown
            }, {
              append: _withCtx(() => [
                _createVNode(_unref(IconButton), {
                  icon: "forward",
                  tooltip: "Send message",
                  onClick: handleSendMessage
                })
              ]),
              _: 1
            }, 8, ["modelValue", "loading", "disable"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})